import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

export interface DesignerProductLoadMoreState {
    loadMoreDesignerProducts: boolean;
}
const initialState: DesignerProductLoadMoreState = {
    loadMoreDesignerProducts: false,
};

const reducer = {
    "Custom/DesignerProducts/SetLoadMoreDesignerProducts": (draft: Draft<DesignerProductLoadMoreState>, action: { result: boolean }) => {
        draft.loadMoreDesignerProducts = action.result;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
